import React from 'react'

const Range = React.createClass({

	propTypes: {
		min: React.PropTypes.number.isRequired,
		max: React.PropTypes.number.isRequired,
		value: React.PropTypes.array.isRequired,
		onChange: React.PropTypes.func
	},

	getDefaultProps() {
		return {
			min: 0,
			max: 100,
			value: [0, 100]
		};
	},

	calcStep(min, max) {
		return ((max || this.props.max) - (min || this.props.min)) / 10
	},

	minStep(value, i, step) {
		if(Math.abs(value[i] - value[1 - i]) < step) {
			return value[1 - i] + step * (i * 2 - 1)
		} else {
			return value[i]
		}
	},

	handleChange(i, evt) {
		let value = this.props.value
		value[i] = parseFloat(evt.target.value)
		value[i] = this.minStep(value, i, this.calcStep())

		this.props.onChange &&
			this.props.onChange(value)
	},

	render() {
		const { value, min, max } = this.props;
		const left = (value[0] - min) / (max - min) * 100 + 1.5;
		const width = (value[1] - min) / (max - min) * 100 - left;

		return (
			<div className="range-slider">
				<div className="range-slider__track" />
				<div className="range-slider__value" style={{left: `${left}%`, width: `${width}%`}} />
				<input type="range" min={min} step={this.calcStep} max={max} value={value[0]} onChange={this.handleChange.bind(this, 0)} />
				<input type="range" min={min} step={this.calcStep} max={max} value={value[1]} onChange={this.handleChange.bind(this, 1)} />
			</div>
		)
	}

})

export default Range


/** WEBPACK FOOTER **
 ** ./src/scripts/components/Range/Range.js
 **/